// extracted by mini-css-extract-plugin
export default {"TextContainer":"TopTextSection_TextContainer__xOreP","Title":"TopTextSection_Title__7gLcJ","SubText":"TopTextSection_SubText__pHgXF"};